import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);
  const navLinks = [{
    name: 'About',
    href: '#',
    active: false
  }, {
    name: 'List for 1%',
    href: '#',
    active: true
  }, {
    name: 'Buyer Rebate',
    href: '#',
    active: false
  }, {
    name: 'FAQ',
    href: '#',
    active: false
  }, {
    name: 'Contact',
    href: '#',
    active: false
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-4'}`} data-id="element-152">
        <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-153">
          {/* Logo */}
          <a href="#" className="flex items-baseline gap-1 z-50 relative" data-id="element-154">
            <span className="font-serif text-2xl md:text-3xl font-bold text-brick-red" data-id="element-155">
              1%
            </span>
            <span className={`font-serif text-2xl md:text-3xl font-bold ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-156">
              AZ
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-157">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-brick-red ${isScrolled ? 'text-charcoal' : 'text-white/90'}`} data-id="element-158">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-159">
            <a href="tel:4802562262" className={`text-sm font-medium transition-colors hover:text-brick-red ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-160">
              (480) 256-2262
            </a>
            <Button variant="outline" className={isScrolled ? 'border-brick-red text-brick-red hover:bg-brick-red hover:text-white' : 'border-white text-white hover:bg-white hover:text-charcoal bg-transparent'} data-id="element-161">
              Free Consultation
            </Button>
          </div>

          {/* Mobile Menu Trigger */}
          <div className="lg:hidden flex items-center" data-id="element-162">
            <button onClick={() => setMobileMenuOpen(true)} className={`w-11 h-11 flex items-center justify-center rounded-sm ${isScrolled ? 'text-charcoal' : 'text-white'}`} aria-label="Open menu" data-id="element-163">
              <Menu className="h-6 w-6" data-id="element-164" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay + Drawer */}
      {mobileMenuOpen && <div className="fixed inset-0 z-[100]" data-id="element-165">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60" onClick={() => setMobileMenuOpen(false)} data-id="element-166" />

          {/* Drawer */}
          <div className="absolute top-0 right-0 bottom-0 w-[85%] max-w-[400px] bg-white flex flex-col" style={{
        boxShadow: '-4px 0 24px rgba(0,0,0,0.15)'
      }} data-id="element-167">
            {/* Header Row */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-black/6" data-id="element-168">
              <span className="font-serif text-2xl" data-id="element-169">
                <span className="text-brick-red font-bold" data-id="element-170">1%</span>{' '}
                <span className="text-charcoal font-bold" data-id="element-171">AZ</span>
              </span>
              <button onClick={() => setMobileMenuOpen(false)} className="w-11 h-11 flex items-center justify-center rounded-sm text-charcoal hover:bg-black/5 transition-colors" aria-label="Close menu" data-id="element-172">
                <X className="h-6 w-6" data-id="element-173" />
              </button>
            </div>

            {/* Nav Links — scrollable */}
            <nav className="flex-1 overflow-y-auto" data-id="element-174">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className={`block text-lg font-medium text-charcoal hover:text-brick-red transition-colors px-6 py-4 border-b border-black/[0.06] ${link.active ? 'border-l-[3px] border-l-brick-red font-semibold bg-cream/50' : ''}`} data-id="element-175">
                  {link.name}
                </a>)}
            </nav>

            {/* Bottom CTA Section */}
            <div className="bg-cream px-6 py-6 border-t border-black/[0.08]" data-id="element-176">
              <div className="text-center mb-4" data-id="element-177">
                <span className="text-gold text-[11px] font-bold tracking-[0.15em] uppercase block mb-1" data-id="element-178">
                  Call Us
                </span>
                <a href="tel:4802562262" className="text-charcoal text-xl font-serif font-semibold flex items-center justify-center gap-2" data-id="element-179">
                  <Phone className="w-4 h-4 text-brick-red" data-id="element-180" />
                  (480) 256-2262
                </a>
              </div>
              <Button className="w-full bg-brick-red hover:bg-brick-red-dark text-white h-12 text-base font-medium" onClick={() => setMobileMenuOpen(false)} data-id="element-181">
                Free Consultation
              </Button>
            </div>
          </div>
        </div>}
    </>;
}